import { useLocation } from 'react-router-dom';
import { useCaseStudyChrome } from '../components/CaseStudyMotion/CaseStudyChromeContext';
import usePrefersReducedMotion from './usePrefersReducedMotion';
import { isFigmaCapture } from '../utils/figmaCapture';

/** Figma html-to-design skips opacity:0 — disable motion while capturing. */

export default function useMotionEnabled() {
  const chrome = useCaseStudyChrome();
  const { pathname } = useLocation();
  const prefersReducedMotion = usePrefersReducedMotion();
  const onCaseStudy = /^\/work\/[^/]+/.test(pathname);

  if (isFigmaCapture) return false;
  if (prefersReducedMotion) return false;
  if (onCaseStudy) return Boolean(chrome?.motionEnabled);
  return true;
}
